/* eslint-disable import/no-extraneous-dependencies,react/no-danger */
import { Button, Tooltip, utils } from 'crux';
import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import styled, { withTheme } from 'styled-components';
import { at } from 'lodash';
import './ReviewLabel.css';
import { ErrorTypes } from '../../../util';
import { getNextQuestionSet } from '../../../redux/actions';
import { sanitizeInnerHtml, scrollQuestionIntoView } from '../../../utils';
import { getCurrentQuestionSet } from '../../../redux/selector/questions';
import { getCSSVariables } from '../../../cruxComponents/utils';

const ButtonWrapper = styled.div`
  ${({ btnTheme }) => `
    margin-bottom: 30px;
    border: ${btnTheme.border};
    & > button {
      &:focus {
        border: ${btnTheme.borderOnFocus};
        border-radius: ${btnTheme.borderRadius};
        outline: ${btnTheme.outline};
      }
    }
  `}
`;

const TooltipIcon = styled.div`
  margin: 0px 10px;
`;

class ReviewLabel extends React.Component {
  componentDidMount() {
    const {
      questionObj: { question_id: questionId, response },
    } = this.props;

    if (response) {
      const { handleLabelChange } = this.props;
      handleLabelChange(questionId, response, ErrorTypes.noError);
    }
  }

  render() {
    const {
      questionObj: {
        question_id: questionId,
        question_text: questionText,
        question_type: questionType,
        is_edit_icon_visible: isEditable,
        presentation_type: presentationType,
        className: questionClassName,
        orientation,
        response,
        validations,
        properties,
      },
      uid,
      theme,
      isReview,
      makeAPICall,
      tooltipProps,
      screenViewport,
      role,
    } = this.props;

    let _orientation = orientation;
    if (questionId.match('Signature') || screenViewport === 'mobile') {
      _orientation = 'columns';
    }
    if (isReview && questionType === 'group') {
      _orientation = 'rows';
    }
    let responseText = response;
    if (response) {
      const { label } = response;
      if (label) responseText = label;
    }
    if (validations?.mask?.mask_on_blur) responseText = utils.maskInputValue(validations, response);

    let metric = {};
    if (validations && validations.metric) {
      metric = validations.metric;
    }

    let parentGroupId = '';

    if (properties && properties.parent_group_id) {
      parentGroupId = properties.parent_group_id.split('_').join(' ');
    }

    if (metric && metric.value) {
      const metricValue = metric.value;
      if (metric.display_position && metric.display_position === 'postfix') {
        responseText = `${responseText}${metricValue}`;
      } else if (metric.display_position && metric.display_position === 'prefix')
        responseText = `${metricValue}${responseText}`;
    }

    const displayUpdateButton = questionType === 'group' && isEditable;
    const handleUpdate = () => {
      const params = {
        uid,
        q_id: questionId,
      };
      makeAPICall(params);
    };

    const getQuestionTextClass = () => {
      let className = `display_review_question ${_orientation} `;
      if (questionType === 'group') className += 'group-question ';
      else if (
        questionType === 'label' &&
        presentationType === 'review' &&
        questionClassName !== 'flex2'
      )
        className += 'labelText';
      else className += 'display_normal';
      // className += questionType === 'label' && (questionClassName || ' display_label');
      return className;
    };

    const updateButtonTheme = get(theme, 'config.theme.global.updateButton.themeConfiguration', {});
    const textElement = questionType === 'group' ? '.reviewlabel-group' : '.reviewlabel-text';
    const desElement = '.reviewlabel-des';
    const cssVariables = getCSSVariables(theme);
    const updateButtonElement = '.button-update';
    const textFont = at(cssVariables, [
      `pageOverride.font${textElement}`,
      `global.font${textElement}`,
    ]);
    const desFont = at(cssVariables, [
      `pageOverride.font${desElement}`,
      `global.font${desElement}`,
    ]);
    const updateButtonFont = at(cssVariables, [
      `pageOverride.font${updateButtonElement}`,
      `global.font${updateButtonElement}`,
    ]);
    updateButtonTheme.font = updateButtonFont[0] || updateButtonFont[1];
    const tooltipColor = get(theme, 'config.theme.global.toolTip.color', '');
    const tooltipFont = get(theme, 'config.theme.global.toolTip.font', '');
    let updatedQuestionText = questionText?.replace('h2', 'h3');
    updatedQuestionText = updatedQuestionText?.replace('tabindex=\'0\'', '');

    const handleOnFocus = (e) => {
      const element = e.target;
      scrollQuestionIntoView({
        element,
        theme,
        role,
        screenViewport,
      });
    };

    return (
      <div key={ questionId }>
        <div className={ `display_review_flex_center ${_orientation}` }>
          <div className={ getQuestionTextClass() }>
            {questionType === 'group' ? (
              <h3
                style={ { font: textFont[0] || textFont[1] } }
                htmlFor={ questionId }
                id={ questionId }
                dangerouslySetInnerHTML={ { __html: sanitizeInnerHtml(questionText) } }
              />
            ) : (
              <div
                style={ { font: textFont[0] || textFont[1] } }
                htmlFor={ questionId }
                dangerouslySetInnerHTML={ { __html: sanitizeInnerHtml(updatedQuestionText) } }
              />
            )}
            {tooltipProps.hasTooltip && (
              <TooltipIcon>
                <Tooltip
                  ariaLabel={ `${questionText} info dialog` }
                  removeAriaLabelforPopper
                  name='tool-tip'
                  color={ tooltipColor }
                  themeConfiguration={ { tooltipFont, tooltipTextColor: tooltipColor } }
                  { ...tooltipProps }
                />
              </TooltipIcon>
            )}
          </div>
          {displayUpdateButton ? (
            <ButtonWrapper btnTheme={ updateButtonTheme }>
              <Button
                label='Update'
                type='text'
                onFocus={ handleOnFocus }
                handleButtonClick={ handleUpdate }
                ariaLabel={ `Update ${questionText || parentGroupId}` }
                themeConfiguration={ updateButtonTheme }
              />
            </ButtonWrapper>
          ) : (
            <div
              className={ `display_review_answer ${_orientation}` }
              style={ { font: desFont[0] || desFont[1] } }
              dangerouslySetInnerHTML={ {
                __html: sanitizeInnerHtml(responseText),
              } }
            />
          )}
        </div>
        <div className='review-dotted-line-break' />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { review } = getCurrentQuestionSet(state);
  const role = get(state, 'questions.role', '');
  return {
    isReview: review && review.isReview,
    uid: state.uid,
    screenViewport: state.meta.screenViewport,
    role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    makeAPICall: (params) => {
      dispatch(getNextQuestionSet('/questions', params));
    },
  };
};

export default withTheme(connect(mapStateToProps, mapDispatchToProps)(ReviewLabel));
